import React, { lazy } from 'react'

import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

import { AssetAcquisitionRouter } from './asset-acquisition/_router'
import { AssetResourceRouter } from './asset-resource/_router'
import { CrewTypeRouter } from './crew-type/_router'
import { CrewWageRouter } from './crew-wage/_router'
import { CrewWageCarRouter } from './crew-wage-car/_router'
import { CrewWageCarAssignmentRouter } from './crew-wage-car-assignment/_router'
import { ExpenseDraftRouter } from './expense-draft/_router'
import { LeaveRequestRouter } from './leave-request/_router'
import { LeaveTypeRouter } from './leave-type/_router'
import { PublicHolidayRouter } from './public-holiday/_router'
import { RosterRouter } from './roster/_router'
import { WorkingTimeRouter } from './time/_router'
import { VolunteerDaysRouter } from './volunteer-days/_router'

const Index = lazy(() => import('./Index'))

export const HumanResourcesRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources']}>
    <Route index element={<Index />} />
    <Route path='crew-wage/*' element={<CrewWageRouter />} />
    <Route path='crew-wage-car/*' element={<CrewWageCarRouter />} />
    <Route path='crew-wage-car-assignment/*' element={<CrewWageCarAssignmentRouter />} />
    <Route path='crew-type/*' element={<CrewTypeRouter />} />
    <Route path='expense-draft/*' element={<ExpenseDraftRouter />} />
    <Route path='asset-resource/*' element={<AssetResourceRouter />} />
    <Route path='asset-acquisition/*' element={<AssetAcquisitionRouter />} />
    <Route path='roster/*' element={<RosterRouter />} />
    <Route path='leave-type/*' element={<LeaveTypeRouter />} />
    <Route path='leave-request/*' element={<LeaveRequestRouter />} />
    <Route path='public-holiday/*' element={<PublicHolidayRouter />} />
    <Route path='volunteer-days/*' element={<VolunteerDaysRouter />} />
    <Route path='time/*' element={<WorkingTimeRouter />} />
  </SubRouter>
))
